// TODO fix jsx-a11y

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/no-static-element-interactions */
import cn from 'classnames';
import he from 'he';
import Link from 'next/link';
import React from 'react';

import { getNounForm, parseMusicians } from '@shared/libs';
import type { Locale } from '@shared/libs';
import { NotesCardQueryData, Notes } from '@shared/types';
import { H3, H4, Int3, P1, P3 } from '@shared/ui';

import styles from './description.module.css';
import { Text } from './text';

const Description: React.FC<{
  handleScrollToSimilar: () => void;
  handleScrollToQuestions: () => void;
  handleScrollToReviews: () => void;
  // eslint-disable-next-line react/no-unused-prop-types
  handleScrollToDownload: () => void;
  data: NotesCardQueryData['data'];
  locale: Locale;
  musiciansArrangement: Notes[];
  hasSimilarMusicians: boolean;
}> = ({ handleScrollToSimilar, handleScrollToQuestions, handleScrollToReviews, data, locale, musiciansArrangement, hasSimilarMusicians }) => {
  const {
    article,
    genres,
    title,
    text,
    rating,
    instruments,
    musicians,
    arrangement,
    id,
    vote_count,
    price,
    year,
    pdfpages,
    collections,
    complexity,
    rate,
    tonality,
    licensed,
    author_words,
    author_music,
    author,
  } = data;
  if (!data) return null;

  return (
    <div className={styles.description}>
      <div className={styles.tabsWrap}>
        <div className={styles.tabs}>
          <div className={cn(styles.tab, styles.active)}>{locale.NOTE_TAB_DSCR}</div>
          {hasSimilarMusicians && (
            <div className={styles.tab} onClick={handleScrollToSimilar}>
              {locale.NOTE_TAB_RECOMMEND}
            </div>
          )}
          <div className={styles.tab} onClick={handleScrollToQuestions}>
            {locale.NOTE_TAB_QUESTIONS}
          </div>
          <div className={styles.tab} onClick={handleScrollToReviews}>
            {locale.NOTE_TAB_REVIEWS}
          </div>
          {/* <div>Ревью</div> */}
          {/* <div className={styles.tab} onClick={handleScrollToDownload}>
            {locale.NOTE_TAB_DOWNLOAD}
          </div> */}
        </div>
      </div>
      <div className={styles.charsContent}>
        <div className={cn(styles.column, styles.left)}>
          <H3 className={styles.charsTitle} unboundedFont={false}>
            {data.NOTE_TAB_DSCR_TITLE_1_BACK}
          </H3>
          <Text locale={locale} data={data} />
          <H3 className={styles.charsTitle} unboundedFont={false}>
            {`${locale.NOTE_TAB_DSCR_TITLE_2} ${parseMusicians(musicians)} ${he.decode(title)}`}
          </H3>
          <div className={styles.descSection}>
            <div className={styles.descBlock}>
              <div className={styles.row}>
                <div className={styles.wrapTitle}>
                  <P1 className={styles.rowTitle}>{locale.NOTE_NAME}</P1>
                  <div className={styles.divider} />
                </div>
                <P1 className={styles.tableContent}>{he.decode(title)}</P1>
              </div>
              <div className={styles.row}>
                <div className={styles.wrapTitle}>
                  <P1 className={styles.rowTitle}>{locale.NOTE_ACTOR}</P1>
                  <div className={styles.divider} />
                </div>
                <P1 className={styles.tableContent}>{parseMusicians(musicians)}</P1>
              </div>
              <div className={styles.row}>
                <div className={styles.wrapTitle}>
                  <P1 className={styles.rowTitle}>{locale.NOTE_GENRE}</P1>
                  <div className={styles.divider} />
                </div>
                <P1 className={styles.tableContent}>{genres?.map((g) => g.title).join(', ')}</P1>
              </div>
              {/* <div className={styles.row}>
                <P1 className={styles.rowTitle}>{locale.NOTE_DURATION}</P1>
                <div className={styles.divider} />
                <P1 className={styles.tableContent}>{}</P1>
              </div> */}
              <div className={styles.row}>
                <div className={styles.wrapTitle}>
                  <P1 className={styles.rowTitle}>{locale.NOTE_YEAR}</P1>
                  <div className={styles.divider} />
                </div>
                <P1 className={styles.tableContent}>{year}</P1>
              </div>
              {false && (
                <div className={styles.row}>
                  <div className={styles.wrapTitle}>
                    <P1 className={styles.rowTitle}>{locale.NOTE_FROM}</P1>
                    <div className={styles.divider} />
                  </div>
                  <P1 className={styles.tableContent}>{}</P1>
                </div>
              )}
              {text && (
                <div className={styles.row}>
                  <div className={styles.wrapTitle}>
                    <P1 className={styles.rowTitle}>{locale.NOTE_TEXT}</P1>
                    <div className={styles.divider} />
                  </div>
                  <P1 className={cn(styles.tableContent, styles.lyrics)}>{text}</P1>
                </div>
              )}
            </div>

            {(licensed || author_words || author_music || author) && (
              <div className={styles.descBlock}>
                <div className={styles.headers}>
                  {licensed && (
                    <div className={styles.row}>
                      <div className={styles.wrapTitle}>
                        <P1 className={styles.rowTitle}>{locale.NOTE_LICENSED}</P1>
                        <div className={styles.divider} />
                      </div>
                      <P1 className={styles.tableContent}>{he.decode(licensed)}</P1>
                    </div>
                  )}
                  {author_words && (
                    <div className={styles.row}>
                      <div className={styles.wrapTitle}>
                        <P1 className={styles.rowTitle}>{locale.NOTE_AUTHOR_WORDS}</P1>
                        <div className={styles.divider} />
                      </div>
                      <P1 className={cn(styles.tableContent, styles.lyrics)}>{author_words}</P1>
                    </div>
                  )}
                  {author_music && (
                    <div className={styles.row}>
                      <div className={styles.wrapTitle}>
                        <P1 className={styles.rowTitle}>{locale.NOTE_AUTHOR_MUSIC}</P1>
                        <div className={styles.divider} />
                      </div>
                      <P1 className={cn(styles.tableContent, styles.lyrics)}>{author_music}</P1>
                    </div>
                  )}
                  {author && (
                    <div className={styles.row}>
                      <div className={styles.wrapTitle}>
                        <P1 className={styles.rowTitle}>{locale.NOTE_AUTHOR}</P1>
                        <div className={styles.divider} />
                      </div>
                      <P1 className={cn(styles.tableContent, styles.lyrics)}>{author}</P1>
                    </div>
                  )}
                </div>
              </div>
            )}

            <div className={styles.descBlock}>
              <div className={styles.headers}>
                {complexity && (
                  <div className={styles.row}>
                    <div className={styles.wrapTitle}>
                      <P1 className={styles.rowTitle}>{locale.NOTE_COMPLEXITY}</P1>
                      <div className={styles.divider} />
                    </div>
                    <P1 className={styles.tableContent}>{complexity.title}</P1>
                  </div>
                )}
                {rate && (
                  <div className={styles.row}>
                    <div className={styles.wrapTitle}>
                      <P1 className={styles.rowTitle}>{locale.NOTE_RATE}</P1>
                      <div className={styles.divider} />
                    </div>
                    <P1 className={styles.tableContent}>{rate}</P1>
                  </div>
                )}
                {tonality && (
                  <div className={styles.row}>
                    <div className={styles.wrapTitle}>
                      <P1 className={styles.rowTitle}>{locale.NOTE_TONALITY}</P1>
                      <div className={styles.divider} />
                    </div>
                    <P1 className={styles.tableContent}>{tonality}</P1>
                  </div>
                )}
                {instruments && (
                  <div className={styles.row}>
                    <div className={styles.wrapTitle}>
                      <P1 className={styles.rowTitle}>{locale.NOTE_FOR_INSTRUMENTS}</P1>
                      <div className={styles.divider} />
                    </div>
                    <P1 className={styles.tableContent}>
                      {instruments.map((arr) => arr.title).join(', ')}
                    </P1>
                  </div>
                )}
                {arrangement && (
                  <div className={styles.row}>
                    <div className={styles.wrapTitle}>
                      <P1 className={styles.rowTitle}>{locale.NOTE_TYPE_ARRANGEMENT}</P1>
                      <div className={styles.divider} />
                    </div>
                    <P1 className={styles.tableContent}>{arrangement.title}</P1>
                  </div>
                )}
                {false && (
                  <div className={styles.row}>
                    <div className={styles.wrapTitle}>
                      <P1 className={styles.rowTitle}>{locale.NOTE_AUTHOR_MUSIC}</P1>
                      <div className={styles.divider} />
                    </div>
                    <P1 className={styles.tableContent}>{}</P1>
                  </div>
                )}
                {false && (
                  <div className={styles.row}>
                    <div className={styles.wrapTitle}>
                      <P1 className={styles.rowTitle}>{locale.NOTE_AUTHOR_WORDS}</P1>
                      <div className={styles.divider} />
                    </div>
                    <P1 className={styles.tableContent}>{}</P1>
                  </div>
                )}
              </div>
            </div>

            <div className={styles.descBlock}>
              <div className={styles.headers}>
                <div className={styles.row}>
                  <div className={styles.wrapTitle}>
                    <P1 className={styles.rowTitle}>{locale.NOTE_ARTICLE}</P1>
                    <div className={styles.divider} />
                  </div>
                  <P1 className={styles.tableContent}>{article}</P1>
                </div>
                {pdfpages && (
                  <div className={styles.row}>
                    <div className={styles.wrapTitle}>
                      <P1 className={styles.rowTitle}>{locale.NOTE_NUMBER_PAGES}</P1>
                      <div className={styles.divider} />
                    </div>
                    <P1 className={styles.tableContent}>{pdfpages}</P1>
                  </div>
                )}
                {Boolean(price) && (
                  <div className={styles.row}>
                    <div className={styles.wrapTitle}>
                      <P1 className={styles.rowTitle}>{locale.NOTE_PRICE}</P1>
                      <div className={styles.divider} />
                    </div>
                    <P1 className={styles.tableContent}>
                      <span className={styles.tableContentText}>
                        {`${price.BASE?.PRINT_VALUE}, ${price.MIDI?.PRINT_VALUE}`}
                      </span>
                    </P1>
                  </div>
                )}
                {/* <P1>Партитура с текстом</P1> */}
                <div className={styles.row}>
                  <div className={styles.wrapTitle}>
                    <P1 className={styles.rowTitle}>{locale.NOTE_FORMAT_DOWNLOAD}</P1>
                    <div className={styles.divider} />
                  </div>
                  <P1 className={styles.tableContent}>
                    <span className={styles.tableContentText}>PDF, MIDI</span>
                  </P1>
                </div>
              </div>
            </div>

            <div className={styles.descBlock}>
              <div className={styles.headers}>
                {Boolean(rating) && (
                  <div className={styles.row}>
                    <div className={styles.wrapTitle}>
                      <P1 className={styles.rowTitle}>{locale.EVALUATION}</P1>
                      <div className={styles.divider} />
                    </div>
                    <P1 className={styles.tableContent}>
                      <span className={styles.tableContentText}>
                        {`${rating} ${locale.EVALUATION_MAX} ${vote_count}
                        ${getNounForm(vote_count, [
                          locale.EVALUATION_ONE || '',
                          locale.EVALUATION_TWO || '',
                          locale.EVALUATION_MANY || '',
                        ])}`}
                      </span>
                    </P1>
                  </div>
                )}
                {/* <P1>Популярный отзыв</P1> */}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.column}>
          {musiciansArrangement.length ? (
            <div className={styles.adds}>
              <div className={styles.titleMusic}>
                <P3 className={styles.addsTitle}>
                  {`${locale.NOTE_OTHER_SCORES} ${parseMusicians(musicians).toUpperCase()}`}
                </P3>
              </div>
              <div className={styles.addsLinks}>
                {musiciansArrangement.map(
                  ({
                    title: titleMusicians,
                    url,
                    id: idMusicians,
                    arrangement: arrangementMusicians,
                    musicians: musiciansMusicians,
                  }) =>
                    Number(id) !== idMusicians ? (
                      <Link key={idMusicians} href={url} prefetch={false}>
                        {`${
                          musiciansMusicians?.length &&
                          `${he.decode(musiciansMusicians[0]?.title || '')} - `
                        }${he.decode(titleMusicians || '')} ${
                          arrangementMusicians &&
                          ` - ${he.decode(arrangementMusicians.title || '')}`
                        }`}
                      </Link>
                    ) : null,
                )}
              </div>
            </div>
          ) : null}
          {collections?.map(({ id: idCollections, title: titleCollection, url }) => (
            <Link key={idCollections} href={url} className={styles.adds} prefetch={false}>
              <div className={styles.titleLink}>
                <Int3 className={styles.addsTitle}>{locale.NOTE_INCLUDED_COLLECTION}</Int3>
              </div>
              <H4 unboundedFont={false}>{he.decode(titleCollection || '')}</H4>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Description;
